import { AdminContextType, AdminStateProps } from "./types";

export const defaultValues: AdminContextType = {
  adminState: {
    selectedEnterprise: undefined,
    selectedMainAccountId: undefined,
    selectedScreen: "CRUD",
  },
  updateState: (_newState: Partial<AdminStateProps>) => null,
};
